import { Validator, errorMessages } from 'services/validator'
import {
  FIRST_NAME_PROPERTY,
  LAST_NAME_PROPERTY,
  ADDRESS_LINE1_PROPERTY,
  ADDRESS_LINE2_PROPERTY,
  CITY_PROPERTY,
  STATE_PROPERTY,
  ZIP_CODE_PROPERTY,
  CELL_PHONE_NUMBER_PROPERTY,
  OTHER_PHONE_NUMBER_PROPERTY
} from './constants'

const REQUIRED_ADDRESS_PROPERTIES = [ADDRESS_LINE1_PROPERTY, CITY_PROPERTY, STATE_PROPERTY, ZIP_CODE_PROPERTY]

export default Validator.combineValidators({
  [FIRST_NAME_PROPERTY]: {
    validators: Validator.firstName(),
    errorMessage: errorMessages.FIRST_NAME_ERROR_MESSAGE
  },
  [LAST_NAME_PROPERTY]: {
    validators: Validator.lastName(),
    errorMessage: errorMessages.LAST_NAME_ERROR_MESSAGE
  },
  [ADDRESS_LINE1_PROPERTY]: [
    {
      validators: Validator.notWhiteSpaceString(),
      errorMessage: errorMessages.ADDRESS_ERROR_MESSAGE
    },
    {
      validators: Validator.address1(),
      errorMessage: errorMessages.ADDRESS_ERROR_MESSAGE
    }
  ],
  [ADDRESS_LINE2_PROPERTY]: {
    validators: Validator.address2(),
    errorMessage: errorMessages.ADDRESS_ERROR_MESSAGE
  },
  [CITY_PROPERTY]: [
    {
      validators: Validator.notWhiteSpaceString(),
      errorMessage: errorMessages.ADDRESS_ERROR_MESSAGE
    },
    {
      validators: Validator.city(),
      errorMessage: errorMessages.CITY_ERROR_MESSAGE
    }
  ],
  [ZIP_CODE_PROPERTY]: {
    validators: Validator.zipCode(),
    errorMessage: errorMessages.ZIP_CODE_ERROR_MESSAGE
  },
  [CELL_PHONE_NUMBER_PROPERTY]: {
    validators: Validator.primaryPhone(),
    errorMessage: errorMessages.CELL_PHONE_ERROR_MESSAGE
  },
  [OTHER_PHONE_NUMBER_PROPERTY]: {
    validators: Validator.alternatePhone(),
    errorMessage: errorMessages.OTHER_PHONE_ERROR_MESSAGE
  },
  _error: {
    validators: (value, values) => {
      const specifiedPropertiesCount = REQUIRED_ADDRESS_PROPERTIES
        .filter(field => Boolean(values[field])).length

      return (specifiedPropertiesCount === 0 && !values[ADDRESS_LINE2_PROPERTY]) ||
        specifiedPropertiesCount === REQUIRED_ADDRESS_PROPERTIES.length
    },
    errorMessage: errorMessages.ADDRESS_GLOBAL_ERROR_MESSAGE
  }
})
